function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.828,
    height: 12.828,
    viewBox: "0 0 12.828 12.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "x (2)",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    style: {
      fill: "none",
      stroke: "#0a243f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M10 0 0 10",
    transform: "translate(1.414 1.414)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 12",
    style: {
      fill: "none",
      stroke: "#0a243f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "m0 0 10 10",
    transform: "translate(1.414 1.414)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveImageIcon);
export default __webpack_public_path__ + "static/media/RemoveImageIcon.ef44974cdc689411738c1a19c72a3299.svg";
export { ForwardRef as ReactComponent };